import { Button } from "rsuite";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import PageBase from "../../components/PageBase";
import styles from "./RiderIndex.module.css";

export default function RiderIndex() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "乘客專區";
  }, []);

  const header = (
    <Header
      HeaderTitle="乘客專區"
      isShowRefresh={false}
      OnReturn={() => {
        navigate("/rider");
      }}
      OnRefresh={() => {}}
    ></Header>
  );

  return (
    <PageBase
      header={header}
      content={
        <div className={styles.page}>
          <section className={styles.hero}>
            <p className={styles.eyebrow}>EASYRIDE</p>
            <h1 className={styles.title}>乘客專區</h1>
            <p className={styles.subtitle}>快速預約、管理行程與付款資訊。</p>
          </section>

          <section className={styles.actions}>
            <Button className={styles.actionButton} onClick={() => navigate("./order/create")}>
              預約接送
            </Button>
            <Button className={styles.actionButton} onClick={() => navigate("./order")}>
              我的訂單
            </Button>
            <Button className={styles.actionButton} onClick={() => navigate("./order/blind-create")}>
              快速付款
            </Button>
            <Button className={styles.actionButton} onClick={() => navigate("/profile")}>
              我的資料
            </Button>
          </section>
        </div>
      }
      showSide
    />
  );
}
